module.exports = __webpack_public_path__ + "static/media/swedbank-logo.37e6b000.svg";